import React from 'react';
import { WalletButton as TxnlabWalletButton } from '@txnlab/use-wallet-ui-react';
import { useWallet } from '@txnlab/use-wallet-react';
import { formatShortAddress } from '@txnlab/utils-ts';
import { Wallet, LogOut } from 'lucide-react';
import Button from '../atoms/Button';

interface WalletButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

export const WalletButton: React.FC<WalletButtonProps> = ({ 
  className = '',
  variant = 'outline',
  size = 'md'
}) => {
  const { activeAddress, disconnect } = useWallet();

  if (activeAddress) {
    return (
      <div className="flex items-center gap-2">
        <Button
          variant={variant}
          size={size}
          className={`flex items-center gap-2 ${className}`}
          icon={Wallet}
        >
          {formatShortAddress(activeAddress)}
        </Button>
        <Button
          variant="ghost"
          size={size}
          onClick={() => disconnect()}
          icon={LogOut}
          className="text-gray-500 hover:text-gray-700"
          title="Disconnect wallet"
        />
      </div>
    );
  }

  return (
    <TxnlabWalletButton
      className={`inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
        variant === 'primary' 
          ? 'bg-primary-500 hover:bg-primary-600 text-white focus:ring-primary-500 shadow-lg hover:shadow-xl' 
          : variant === 'secondary'
          ? 'bg-secondary-500 hover:bg-secondary-600 text-white focus:ring-secondary-500 shadow-lg hover:shadow-xl'
          : variant === 'outline'
          ? 'border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white focus:ring-primary-500'
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:ring-gray-500'
      } ${
        size === 'sm' ? 'px-3 py-1.5 text-sm gap-1.5' :
        size === 'lg' ? 'px-6 py-3 text-base gap-2.5' :
        'px-4 py-2 text-sm gap-2'
      } ${className}`}
      label={
        <div className="flex items-center gap-2">
          <Wallet size={size === 'sm' ? 14 : size === 'lg' ? 20 : 16} />
          <span>Connect Wallet</span>
        </div>
      }
    />
  );
};